import { MethodType } from '../constants/MethodType'

const api = require('./api')

export const fetchExport = params => api.request(1, '/dataExports', MethodType.GET, params)

export const addExport = params => api.request(1, '/dataExports', MethodType.POST, params)

export const modExport = (id, params) => api.request(1, `/dataExports/${id}`, MethodType.PUT, params)

export const delExport = (id, params) => api.request(1, `/dataExports/${id}`, MethodType.DELETE, params)

export const fetchExportByBrand = (groupId, brandId, params) => api.request(1, `/getDataExportsByBrand/${groupId}/${brandId}`, MethodType.GET, params)

export const fetchMappingMedia = params => api.request(1, '/mappingMedias', MethodType.GET, params)
